import { useContext, useState, useEffect } from "react";
import { SidebarContext } from "../../context/sidebarContext";
import { UserProvider } from "../../context/userContext";
import Sidebar from "../Sidebar/Sidebar";
import DashboardHeader from "../../components/DashboardHeader/DashboardHeader";

const DashboardLayout = ({
  children,
  navigationLinks,
  roleBasePath,
  useApiLogout = true,
}) => {
  const { isSidebarOpen } = useContext(SidebarContext);
  const [deviceType, setDeviceType] = useState("desktop");

  // Determine device type
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType("mobile");
      } else if (width < 1024) {
        setDeviceType("tablet");
      } else {
        setDeviceType("desktop");
      }
    };

    handleResize(); // Set initial device type
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <UserProvider>
      <div className="w-full h-screen overflow-hidden">
        <div className="flex w-full h-full">
          <Sidebar
            navigationLinks={navigationLinks}
            roleBasePath={roleBasePath}
            useApiLogout={useApiLogout}
          />
          <div className="bg-[#f9f9fa] flex-1 flex flex-col w-full overflow-x-auto transition-all duration-300 ease-in-out">
            <DashboardHeader navigationLinks={navigationLinks} />
            <div className="flex justify-center items-center md:p-4 md:pb-2 w-full flex-1 overflow-hidden">
              <div className="bg-white md:rounded-lg md:border md:shadow w-full h-full overflow-auto">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserProvider>
  );
};

export default DashboardLayout;
